/**
 * Browser only functions.
 * NOTE: This module is "cross platform" and can be used in node.js.
 * Do NOT reference window outside of a function. If you do, you will break
 * things for others.
 */
function getJSONStorage(type) {
    return function (key) {
        try {
            var value = window[type].getItem(key);
            return value ? JSON.parse(value) : null;
        }
        catch (e) {
            return null;
        }
    };
}
function setJSONStorage(type) {
    return function (key, value) {
        window[type].setItem(key, JSON.stringify(value));
    };
}
export var getJSONLocalStorage = getJSONStorage('localStorage');
export var setJSONLocalStorage = setJSONStorage('localStorage');
export var getJSONSessionStorage = getJSONStorage('sessionStorage');
export var setJSONSessionStorage = setJSONStorage('sessionStorage');
/**
 * Given some value (presumably a string), will convert it to a boolean.
 * Semantics: the following values return false: undefined, null, false, 0, NaN,
 * '', 'false', and '0'. Everything else returns `true`.
 */
export function getStringAsBoolean(x) {
    return !(!x || x === 'false' || +x === 0);
}
/**
 * Gets a value from local storage as a boolean.
 * This will convert the stored value from 'true'/'false' to its boolean
 * equivalent.
 */
export function getBooleanLocalStorage(key) {
    return getStringAsBoolean(localStorage.getItem(key));
}
/**
 * Gets a value from session storage as a boolean.
 * This will convert the stored value from 'true'/'false' to its boolean
 * equivalent.
 */
export function getBooleanSessionStorage(key) {
    return getStringAsBoolean(sessionStorage.getItem(key));
}
/**
 * Given an 8 bit decimal number, returns a zero-padded hex value.
 * Warning: Values given > 255 will not be padded properly.
 * 0-255 => 00-ff
 */
function dec2Hex8BitPadded(x) {
    return x < 16 ? "0" + x.toString(16) : x.toString(16);
}
/**
 * Generates a random hex string of length `n`.
 * This can be used to avoid depending on the UUID library in cases where a
 * dynamically generated React component key is unavoidable.
 *
 * @example
 * generateRandomHexString(1)
 * // => [a-f][0-9]{1}
 *
 * generateRandomHexString(2)
 * // => [a-f][0-9]{2}
 */
export function getRandomHexString(n) {
    if (n === void 0) { n = 32; }
    if (n <= 0)
        return '';
    var crypto = window.crypto || window.msCrypto;
    var values = crypto.getRandomValues(new Uint8Array(Math.ceil(n / 2)));
    var result = Array.from(values, dec2Hex8BitPadded).join('');
    return n % 2 === 0 ? result : result.slice(1);
}
/**
 * Generates a unique string of length 32, which is long enough to assure
 * uniqueness up to sqrt(16^32) or 16^16 or ~18,446,744,073,709,552,000
 * calls.
 */
export var uniqueID = function () { return getRandomHexString(32); };
//# sourceMappingURL=browser.js.map